import Vue from "vue";
import VueRouter from "vue-router";
// periodical 期刊
// PC端页面
import pcHome from "../views/pc/pcHome.vue";
// 手机端页面
import h5Home from "../views/h5/h5Home.vue";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    component: pcHome,
    children: [
      {
        path: "/",
        name: "pchome",
        meta: {
          title: "上海市航海学会"
        },
        component: () =>
          import(/* webpackChunkName: "pcHome" */ "../views/pc/home/Home.vue")
      },
      {
        path: "/about",
        name: "/pcabout",
        meta: {
          title: "关于我们"
        },
        component: () =>
          import(
            /* webpackChunkName: "pcAbout" */ "../views/pc/about/aboutHome.vue"
          )
      },
      {
        path: "/new",
        name: "pcnew",
        meta: {
          title: "新闻中心"
        },
        component: () =>
          import(/* webpackChunkName: "pcnew" */ "../views/pc/new/newHome.vue")
      },
      {
        path: "/new/details",
        name: "pcnewDetails",
        meta: {
          title: "新闻详情"
        },
        component: () =>
          import(
            /* webpackChunkName: "pcnew" */ "../views/pc/new/newDetails.vue"
          )
      },
      {
        path: "/new/salonDetails",
        name: "pcnsalonDetails",
        meta: {
          title: "论坛沙龙详情"
        },
        component: () =>
          import(
            /* webpackChunkName: "pcsolnDetails" */ "../views/pc/learning/pages/solnDetails.vue"
          )
      },
      {
        path: "/periodical",
        name: "pcperiodical",
        meta: {
          title: "期刊出版"
        },
        component: () =>
          import(
            /* webpackChunkName: "periodicalHome" */ "../views/pc/periodical/periodicalHome.vue"
          )
      },
      {
        path: "/periodical/details",
        name: "pcperiodicalDetails",
        meta: {
          title: "期刊详情"
        },
        component: () =>
          import(
            /* webpackChunkName: "periodicalHome" */ "../views/pc/periodical/periodicalDetails.vue"
          )
      },
      {
        path: "/learning",
        name: "pclearning",
        meta: {
          title: "学术交流"
        },
        component: () =>
          import(
            /* webpackChunkName: "learning" */ "../views/pc/learning/learningHome.vue"
          )
      },
      {
        path: "/learning/details",
        name: "pclearningDetails",
        meta: {
          title: "专家展示"
        },
        component: () =>
          import(
            /* webpackChunkName: "learning" */ "../views/pc/learning/learningDetails.vue"
          )
      },
      {
        path: "/consulting",
        name: "pcconsulting",
        meta: {
          title: "咨询服务"
        },
        component: () =>
          import(
            /* webpackChunkName: "consulting" */ "../views/pc/consulting/consultingHome.vue"
          )
      },
      {
        path: "/vip",
        name: "pcvip",
        meta: {
          title: "会员中心"
        },
        component: () =>
          import(/* webpackChunkName: "pcvip" */ "../views/pc/vip/vipHome.vue")
      },
      {
        path: "/leaving",
        name: "pcleaving",
        meta: {
          title: "留言反馈"
        },
        component: () =>
          import(
            /* webpackChunkName: "leaving" */ "../views/pc/leaving/leavingHome.vue"
          )
      },
      {
        path: "/branch",
        name: "pcbranch",
        meta: {
          title: "分部介绍"
        },
        component: () =>
          import(
            /* webpackChunkName: "branch" */ "../views/pc/branch/branchHome.vue"
          )
      }
    ]
  },
  {
    path: "/h5",
    component: h5Home,
    children: [
      // salon
      {
        path: "/",
        name: "H5home",
        meta: {
          title: "关于我们"
        },
        component: () =>
          import(/* webpackChunkName: "H5home" */ "../views/h5/home/Home.vue")
      },
      {
        path: "history",
        name: "H5history",
        meta: {
          title: "大事记"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5history" */ "../views/h5/history/historyHome.vue"
          )
      },
      {
        path: "council",
        name: "H5council",
        meta: {
          title: "理事会"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5council" */ "../views/h5/council/councilHome.vue"
          )
      },
      {
        path: "salon",
        name: "H5salon",
        meta: {
          title: "论坛沙龙"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5salon" */ "../views/h5/salon/salonHome.vue"
          )
      },
      {
        path: "salonDetails",
        name: "H5salonDetails",
        meta: {
          title: "沙龙详情"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5salonDetails" */ "../views/h5/salon/salonDetails.vue"
          )
      },
      {
        path: "gardenPlot",
        name: "H5gardenPlot",
        meta: {
          title: "科普园地"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5gardenPlot" */ "../views/h5/gardenPlot/gardenPlotHome.vue"
          )
      },
      {
        path: "gardenPlot/details",
        name: "H5gardenPlotDetails",
        meta: {
          title: "科普详情"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5gardenPlotDetails" */ "../views/h5/gardenPlot/gardenPlotDetails.vue"
          )
      },
      {
        path: "major",
        name: "H5major",
        meta: {
          title: "专业委员会"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5major" */ "../views/h5/major/majorHomeNew.vue"
          )
      },
      {
        path: "expert",
        name: "H5expert",
        meta: {
          title: "专家风采"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5expert" */ "../views/h5/expert/expertHome.vue"
          )
      },
      {
        path: "expert/details",
        name: "H5expertdetails",
        meta: {
          title: "专家详情"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5expert" */ "../views/h5/expert/expertDetails.vue"
          )
      },
      {
        path: "about",
        name: "H5about",
        meta: {
          title: "联系我们"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5about" */ "../views/h5/about/About.vue"
          )
      },
      {
        path: "journal",
        name: "H5Journal",
        meta: {
          title: "航海微刊"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5Journal" */ "../views/h5/journal/journalHome.vue"
          )
      },
      {
        path: "journal/details",
        name: "H5JournalDetails",
        meta: {
          title: "微刊详情"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5Journal" */ "../views/h5/journal/journalDetails.vue"
          )
      },
      {
        path: "libraryList",
        name: "H5libraryList",
        meta: {
          title: "航海微刊"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5libraryList" */ "../views/h5/libraryList/libraryListHome.vue"
          )
      },
      {
        path: "my",
        name: "H5my",
        meta: {
          title: "会员中心"
        },
        component: () =>
          import(/* webpackChunkName: "H5my" */ "../views/h5/my/myHome.vue")
      },
      {
        path: "myData",
        name: "H5myData",
        meta: {
          title: "个人资料"
        },
        component: () =>
          import(/* webpackChunkName: "H5my" */ "../views/h5/my/setMydata.vue")
      },
      {
        path: "sign",
        name: "H5sign",
        meta: {
          title: "注册"
        },
        component: () =>
          import(/* webpackChunkName: "H5sign" */ "../views/h5/Sign/sign.vue")
      },
      {
        path: "vipLink",
        name: "H5vipLink",
        meta: {
          title: "会员中心"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5vipLink" */ "../views/h5/my/vipLink.vue"
          )
      },
      {
        path: "vipLinkDetails",
        name: "H5vipLinkDetails",
        meta: {
          title: "会员中心"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5vipLink" */ "../views/h5/my/vipBox.vue"
          )
      },
      {
        path: "myAbout",
        name: "H5myAbout",
        meta: {
          title: "关于我们"
        },
        component: () =>
          import(/* webpackChunkName: "H5myAbout" */ "../views/h5/my/about.vue")
      },
      {
        path: "book",
        name: "H5book",
        meta: {
          title: "书籍出版"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5book" */ "../views/h5/book/bookHome.vue"
          )
      },
      {
        path: "book/details",
        name: "H5bookdetails",
        meta: {
          title: "书籍详情"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5bookdetails" */ "../views/h5/book/bookDetails.vue"
          )
      },
      {
        path: "book/payBook",
        name: "H5bookpayBook",
        meta: {
          title: "书籍购买"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5bookpayBook" */ "../views/h5/book/payBook.vue"
          )
      },
      {
        path: "technical",
        name: "H5technical",
        meta: {
          title: "技术咨询"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5bookpayBook" */ "../views/h5/technical/technicalHome.vue"
          )
      },
      {
        path: "declare",
        name: "H5declare",
        meta: {
          title: "高级职称申报"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5bookpayBook" */ "../views/h5/technical/declare.vue"
          )
      },
      {
        path: "service",
        name: "H5service",
        meta: {
          title: "磁罗经技术服务"
        },
        component: () =>
          import(
            /* webpackChunkName: "H5bookpayBook" */ "../views/h5/technical/service.vue"
          )
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title;
  window.scrollTo(0, 0);
  next();
});

export default router;
